import { NavLink } from 'react-router-dom';
import {
    LayoutDashboard,
    Calendar,
    Image,
    BarChart3,
    Settings,
    Users,
    Link2,
    Hash,
    Shield,
    X, FileText } from 'lucide-react';
import { Logo } from './Logo';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../ui/button';
import { cn } from '../../lib/utils';

const navItems = [
    { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { to: '/calendar', icon: Calendar, label: 'Calendar' },
    { to: '/drafts', icon: FileText, label: 'Drafts' },
    { to: '/compose', icon: Image, label: 'Create Post' },
    { to: '/media', icon: Image, label: 'Media Library' },
    { to: '/accounts', icon: Link2, label: 'Accounts' },
    { to: '/hashtags', icon: Hash, label: 'Hashtags' },
    { to: '/analytics', icon: BarChart3, label: 'Analytics' },
    { to: '/team', icon: Users, label: 'Team' },
    { to: '/settings', icon: Settings, label: 'Settings' },
];

const adminItems = [
    { to: '/admin', icon: Shield, label: 'Admin Panel' },
];

export const Sidebar = ({ isOpen, onClose }) => {
    const { isAdmin } = useAuth();

    return (
        <>
            {isOpen && (
                <div
                    className="sidebar-overlay"
                    onClick={onClose}
                    data-testid="sidebar-overlay"
                />
            )}
            
            <aside
                className={cn(
                    "fixed left-0 top-0 h-full w-64 border-r border-border bg-card/50 backdrop-blur-xl z-50",
                    "transform transition-transform duration-300 ease-in-out",
                    "lg:translate-x-0",
                    isOpen ? "translate-x-0" : "-translate-x-full"
                )}
                data-testid="sidebar"
            >
                <div className="flex flex-col h-full">
                    <div className="flex items-center justify-between p-6 border-b border-border">
                        <div className="flex items-center gap-3">
                            <Logo className="w-8 h-8" />
                            <span className="text-xl font-bold gradient-text">
                                KyberSocial
                            </span>
                        </div>
                        <Button
                            variant="ghost"
                            size="icon"
                            className="lg:hidden"
                            onClick={onClose}
                            data-testid="close-sidebar-btn"
                        >
                            <X className="h-5 w-5" />
                        </Button>
                    </div>

                    <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
                        {navItems.map((item) => (
                            <NavLink
                                key={item.to}
                                to={item.to}
                                onClick={onClose}
                                className={({ isActive }) =>
                                    cn(
                                        "sidebar-nav-item",
                                        isActive && "active"
                                    )
                                }
                                data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
                            >
                                <item.icon className="h-5 w-5" />
                                <span>{item.label}</span>
                            </NavLink>
                        ))}

                        {isAdmin && (
                            <>
                                <div className="pt-4 pb-2">
                                    <span className="px-4 text-xs font-semibold text-muted-foreground uppercase tracking-wider">
                                        Admin
                                    </span>
                                </div>
                                {adminItems.map((item) => (
                                    <NavLink
                                        key={item.to}
                                        to={item.to}
                                        onClick={onClose}
                                        className={({ isActive }) =>
                                            cn(
                                                "sidebar-nav-item",
                                                isActive && "active"
                                            )
                                        }
                                        data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
                                    >
                                        <item.icon className="h-5 w-5" />
                                        <span>{item.label}</span>
                                    </NavLink>
                                ))}
                            </>
                        )}
                    </nav>

                    <div className="p-4 border-t border-border">
                        <div className="text-xs text-muted-foreground text-center">
                            KyberSocial v2.0
                        </div>
                    </div>
                </div>
            </aside>
        </>
    );
};
